import {h, Component} from 'preact';
import UserAuth from '../../services/userAuth';
import Util from "../../services/util";

export default class SymantecVIPauth extends Component {
    constructor() {
        super();
        this.state = {
            isMobile: Util.isMobile(),
            symantecAuthCode: '',
            symantecError: '',
            nextButtonLoading: false,
            nextButtonDisabled: true,
        }
    }

    componentDidMount() {
        this.props.pollingTimer();
        this.props.focusById('symantecAuthCode');
    }

    enterSymantecAuthCode = e => {
        this.setState({
            symantecAuthCode: e.target.value,
            nextButtonDisabled: false
        });
        if (!e.target.value) {
            this.setState({
                nextButtonDisabled: true
            });
        }
    };

    nextStep = () => {
        if (this.state.nextButtonLoading) {
            console.log('Loading...');
        } else {
            this.setState({symantecError: '', nextButtonLoading: true});
            const activationCode = this.state.symantecAuthCode;
            UserAuth.submitSymantecVipCode({activationCode})
                .then(response => {
                    this.setState({symantecError: ''});
                    const data = response.data;
                    if (data) {
                        const mfaData = {
                            mfa: data
                        };
                        this.props.mfaRedirection(mfaData);
                    } else {
                        this.props.requireNativeAppInstall(data);
                    }
                }, error => {
                    const errorData = error.response.data;
                    this.setState({
                        symantecAuthCode: '',
                        symantecError: errorData,
                        nextButtonLoading: false,
                        nextButtonDisabled: true,
                    });
                });
        }
    };

    onKeypress = e => {
        const keyCode = e.keyCode || e.which;
        if(keyCode === 13){
            e.preventDefault();
            this.nextStep();
        }
    };

    render({renderHelpLink}, {isMobile, symantecAuthCode, symantecError, nextButtonLoading, nextButtonDisabled}) {
        return (
            <div>
                {isMobile ? (
                    <x-mobile>
                        <div className='form'>
                            <form role='form'>
                                <div className="form-group clearfix">
                                    <p className='symantec-error login-error'>{symantecError} &nbsp;</p>
                                    <p>Please generate a security code <br/> with your card or app.</p>
                                    <input
                                        name='symantecAuthCode'
                                        className='form-control'
                                        id='symantecAuthCode'
                                        required
                                        type='text'
                                        placeholder='Security Code'
                                        value={symantecAuthCode}
                                        onInput={this.enterSymantecAuthCode}
                                        onKeyPress={this.onKeypress}
                                    />
                                </div>
                                <div className='form-submit clearfix'>
                                    <a className={`button button-prime nextBtn pull-right ${nextButtonLoading ? 'loading' : ''} ${nextButtonDisabled ? 'disabled' : ''}`}
                                       onClick={this.nextStep}>{nextButtonLoading ? 'Please wait' : 'Next'}</a>
                                </div>
                                <div className='help-link'>
                                    {renderHelpLink('', false)}
                                </div>
                            </form>
                        </div>
                    </x-mobile>
                ) : (
                    <x-desktop>
                        <h3>Symantec VIP setup</h3>
                        <div className='form'>
                            <form role='form'>
                                <div className="form-group clearfix">
                                    <p>Please generate a security code with your card or app.</p>
                                    <label htmlFor="symantecAuthCode">Security Code:</label>
                                    <input
                                        name='symantecAuthCode'
                                        className='form-control'
                                        id='symantecAuthCode'
                                        required
                                        type='text'
                                        placeholder=''
                                        value={symantecAuthCode}
                                        onInput={this.enterSymantecAuthCode}
                                        onKeyPress={this.onKeypress}
                                    />
                                </div>
                                <p className='login-error'>{symantecError} &nbsp;</p>
                                <div className='form-submit clearfix'>
                                    {renderHelpLink('', false)}
                                    <a className={`button button-prime nextBtn ${nextButtonLoading ? 'loading' : ''} ${nextButtonDisabled ? 'disabled' : ''}`}
                                       onClick={this.nextStep}>{nextButtonLoading ? 'Please wait' : 'Next'}</a>
                                </div>
                            </form>
                        </div>
                    </x-desktop>
                )}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/two-factor/symantec-vip-auth.js